import { createFileRoute, Outlet } from '@tanstack/react-router';
export const Route = createFileRoute('/accounting/$type')({ component: Outlet });
